module.exports = __webpack_public_path__ + "img/field-project-dark-8.a59de8f3.svg";